import React, { Fragment } from "react";
import Conversation from "../../../Component/Chat/NewChat/Conversation";
import useLogoutSession from "../../../_helper/LogoutAfterSessionExpiration/useLogoutSession";

const ConversationContain = () => {
  useLogoutSession();
  return (
    <Fragment>
      {/* <Breadcrumbs parent="Chat" title=" Chat App" /> */}
      <div className="pt-2">
        <Conversation />
      </div>
    </Fragment>
  );
};
export default ConversationContain;
